module.exports = __webpack_public_path__ + "static/media/SAP_TEMPLATE_SALES.c44cac18.xlsx";